<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="24">
                    <a-form-item label="图片" name="icon">
                        <ImgUpload v-model:value="form.icon"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="专利名称" name="patentName">
                        <a-input v-model:value="form.patentName" placeholder="请输入专利名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="专利类别" name="patentCategory">
                        <DictSelect
                            v-model:value="form.patentCategory"
                            :dict-name="innovation.PROJECT_TYPE"
                            placeholder="请选择"
                        />
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="专利号" name="patentNumber">
                        <a-input v-model:value="form.patentNumber"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="授权方式" name="accredit">
                        <DictSelect v-model:value="form.accredit"
                    :dict-name="policy.INTELLECTUALSUBSIDY_GET" placeholder="请选择" />
                    </a-form-item>
                </a-col>

                
                <a-col :span="12">
                    <a-form-item label="授权日期" name="authorizationDate">
                        <DatePicker v-model:value="form.authorizationDate" placeholder="请输入授权日期" style="width: 100%"/>
                    </a-form-item>
                </a-col>

                <a-col :span="12">
                    <a-form-item label="专利有效期始" name="validityStart">
                        <DatePicker v-model:value="form.validityStart" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="专利有效期末" name="validityEnd">
                        <DatePicker v-model:value="form.validityEnd" placeholder="请输入认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="专利申请号" name="applicationNumber">
                        <a-input v-model:value="form.applicationNumber"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="说明摘要" name="description">
                        <TinymceEditor v-model:value="form.description"/>
                    </a-form-item>
                </a-col>

                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
    // import dataCheck from "@/utils/dataCheck";
    import {formMixin} from "@/mixins";
    import {patentApi} from "@/api/knowledge";
    import DictSelect from "@/components/other/DictSelect";
    import {policy,innovation} from "@/config/variableConfig";
    import TinymceEditor from "@/components/form/editor/TinymceEditor";

    export default {
        name: "AddOrEditModal",
        components: {TinymceEditor, DictSelect},

        mixins: [formMixin],
        data() {
            return {
                innovation,
                policy,
                form: {
                    id: null,
                    patentCategory: null,
                    patentName: null,
                    accredit: null,
                    brandName: null,
                    patentNumber: null,
                    icon:null,
                    authorizationDate: null,
                    validityStart: null,
                    validityEnd: null,
                    description: null,
                    applicationNumber: null,

                },
                rules: {
                    id: [],
                    patentCategory: [],
                    patentName: [],
                    brandName: [],
                    accredit: [],
                    patentNumber: [],
                    icon:[],
                    authorizationDate: [],
                    validityStart: [],
                    validityEnd: [],
                    description: [],
                    applicationNumber: [],

                },
                submitUrl: patentApi.saveOrUpdate
            }
        },
        mounted() {
        },
        methods: {},
    }
</script>
<style scoped lang="less">
</style>
